import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getAuthToken, setAuthToken } from '../api/client';

const AuthContext = createContext(null);

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [role, setRole] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check for existing token
        const token = getAuthToken();
        if (token) {
            // Decode to get role
            try {
                const payload = JSON.parse(atob(token.split('.')[1]));
                setUser(payload.user);
                setRole(payload.role);
            } catch {
                setAuthToken(null);
            }
        }
        setLoading(false);
    }, []);

    const login = async (password) => {
        const result = await apiLogin(password);

        if (result.success) {
            setUser(result.role === 'owner' ? 'Owner' : 'Worker');
            setRole(result.role);
        }

        return result;
    };

    const logout = () => {
        setAuthToken(null);
        setUser(null);
        setRole(null);
    };

    return (
        <AuthContext.Provider value={{ user, role, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}
